import vc from './vc.png';
import esi from './esi.png';
import di from './di.png';
import eta from './eta.png';
import pe from './pe.png';
import qn from './qn.png';
import ssm from './ssm.png';
import swd from './swd.png';
import yp from './yp.png';
import awd from './awd.png';
import awp from './awp.png';
import awr from './awr.png';
import dfm from './dfm.png';
import fwi from './fwi.png';
import hi from './hi.png';
import utci from './utci.png';
import mdfvc from './mdfvc.png';
import mdfapar from './mdfapar.png';
import mlst from './mlst.png';
import mlstas from './mlst-as.png';
import mgpp from './mgpp.png';
import edlst from './edlst.png';
import frm from './frm.png';
import mdmet from './mdmet.png';
import metref from './metref.png';

const images = {
    vc, esi, di, eta, pe, qn, ssm, swd, yp, awd, awp, awr, dfm, fwi, hi, utci
};

export const getLayerImageByName = (layerName) => {

    switch(layerName) {
        case 'vegetation_condition': return vc;
        case 'yield_prediction': return yp;
        case 'esi': return esi;
        case 'drought_impacts': return di;
        case 'satellite_soil_moisture': return ssm;
        case 'precipitation': return pe;
        case 'soil_water_deficit': return swd;
        case 'eta': return eta;
        case 'qn': return qn;
        case 'awd': return awd;
        case 'awp': return awp;
        case 'awr': return awr;
        case 'dfm': return dfm;
        case 'fwi': return fwi;
        case 'hi': return hi;
        case 'utci': return utci;
        case 'mdfvc': return mdfvc;
        case 'mdfapar': return mdfapar;
        case 'mlst': return mlst;
        case 'mgpp': return mgpp;
        case 'edlst': return edlst;
        case 'mlst-as': return mlstas;
        case 'frm': return frm;
        case 'mdmetv3': return mdmet;
        case 'metref': return metref;
        default: return;
    }

}
